(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@angular/cdk/a11y'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@shraddhar/web/base'), require('@shraddhar/web/list'), require('@material/drawer')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/drawer', ['exports', '@angular/core', '@angular/common', '@angular/cdk/a11y', '@angular/cdk/coercion', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@shraddhar/web/base', '@shraddhar/web/list', '@material/drawer'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.drawer = {}), global.ng.core, global.ng.common, global.ng.cdk.a11y, global.ng.cdk.coercion, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.ng.web.base, global.ng.web.list, global.mdc.drawer));
}(this, (function (exports, core, common, a11y, coercion, platform, rxjs, operators, base, list, drawer) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MdcDrawerHeader = /** @class */ (function () {
        function MdcDrawerHeader(elementRef) {
            this.elementRef = elementRef;
        }
        MdcDrawerHeader.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-drawer-header',
                        template: "\n  <ng-content></ng-content>\n  <h3 class=\"mdc-drawer__title\" *ngIf=\"title\">{{title}}</h3>\n  <h6 class=\"mdc-drawer__subtitle\" *ngIf=\"subtitle\">{{subtitle}}</h6>",
                        host: { 'class': 'mdc-drawer__header' },
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcDrawerHeader.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcDrawerHeader.propDecorators = {
            title: [{ type: core.Input }],
            subtitle: [{ type: core.Input }]
        };
        return MdcDrawerHeader;
    }());
    var MdcDrawer = /** @class */ (function (_super) {
        __extends(MdcDrawer, _super);
        function MdcDrawer(_platform, _ngZone, _changeDetectorRef, _focusTrapFactory, _focusMonitor, _document, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._ngZone = _ngZone;
            _this._changeDetectorRef = _changeDetectorRef;
            _this._focusTrapFactory = _focusTrapFactory;
            _this._focusMonitor = _focusMonitor;
            _this._document = _document;
            _this.elementRef = elementRef;
            /** Emits when the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._scrimElement = null;
            /** Element that was focused before the drawer was opened. Save this to restore upon close. */
            _this._elementFocusedBeforeDrawerWasOpened = null;
            _this._open = false;
            _this._drawer = '';
            _this._autoFocus = true;
            _this._restoreFocus = true;
            _this.opened = new core.EventEmitter();
            _this.closed = new core.EventEmitter();
            /** Event emitted when the drawer open state is changed. */
            _this.openedChange = new core.EventEmitter(/* isAsync */ true);
            /** Event emitted when the drawer variant is changed. */
            _this.drawerChange = new core.EventEmitter(/* isAsync */ true);
            _this._scrimSubscription = null;
            _this.openedChange.subscribe(function (opened) {
                if (opened) {
                    if (_this._document) {
                        _this._elementFocusedBeforeDrawerWasOpened = _this._document.activeElement;
                    }
                    if (_this._isFocusTrapEnabled && _this._focusTrap) {
                        _this._trapFocus();
                    }
                }
                else {
                    _this._releaseFocus();
                }
            });
            _this.drawerChange.subscribe(function () { return _this._initFoundation(); });
            /**
             * Listen to `keydown` events outside the zone so that change detection is not run every
             * time a key is pressed. Instead we re-enter the zone only if the `ESC` key is pressed
             * and we don't have close disabled.
             */
            _this._ngZone.runOutsideAngular(function () {
                rxjs.fromEvent(_this._elementRef.nativeElement, 'keydown')
                    .pipe(operators.takeUntil(_this._destroyed)).subscribe(function (event) { return _this._ngZone.run(function () {
                    _this._foundation.handleKeydown(event);
                    if (_this.modal) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                }); });
            });
            return _this;
        }
        Object.defineProperty(MdcDrawer.prototype, "open", {
            get: function () {
                return this._open;
            },
            set: function (value) {
                if (this._platform.isBrowser && this._open !== value) {
                    this._open = coercion.coerceBooleanProperty(value);
                    this._open ? this._foundation.open() : this._foundation.close();
                    this.openedChange.emit(this._open);
                    this._updateFocusTrapState();
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "drawer", {
            get: function () {
                return this._drawer;
            },
            set: function (drawer) {
                if (this._drawer !== drawer) {
                    this._drawer = drawer;
                    this.drawerChange.emit();
                    this._updateFocusTrapState();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "autoFocus", {
            get: function () {
                return this._autoFocus;
            },
            set: function (value) {
                this._autoFocus = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "restoreFocus", {
            get: function () {
                return this._restoreFocus;
            },
            set: function (value) {
                this._restoreFocus = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "fixedAdjustElement", {
            get: function () {
                return this._fixedAdjustElement;
            },
            set: function (element) {
                this._fixedAdjustElement = element;
                element ? this._getHostElement().style.setProperty('position', 'absolute') :
                    this._getHostElement().style.removeProperty('position');
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "modal", {
            get: function () {
                return this.drawer === 'modal';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "dismissible", {
            get: function () {
                return this.drawer === 'dismissible';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcDrawer.prototype, "_isFocusTrapEnabled", {
            get: function () {
                // The focus trap is only enabled when the drawer is open and modal.
                return this.open && this.modal;
            },
            enumerable: true,
            configurable: true
        });
        MdcDrawer.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                elementHasClass: function (element, className) { return element.classList.contains(className); },
                saveFocus: function () { return _this._savePreviouslyFocusedElement(); },
                restoreFocus: function () { return _this._releaseFocus(); },
                focusActiveNavigationItem: function () {
                    if (!_this._platform.isBrowser || !_this._list || !_this._autoFocus) {
                        return;
                    }
                    var selectedItem = _this._list.getSelectedItem();
                    if (selectedItem) {
                        selectedItem.focus();
                    }
                    else {
                        var cdkInitialItem = _this._platform.isBrowser ?
                            document.querySelector("[cdkFocusInitial]") : null;
                        cdkInitialItem === null || cdkInitialItem === void 0 ? void 0 : cdkInitialItem.focus();
                    }
                },
                notifyClose: function () { return _this.closed.emit(); },
                notifyOpen: function () { return _this.opened.emit(); },
                trapFocus: function () { },
                releaseFocus: function () { return _this._releaseFocus(); }
            };
            return this.modal ? new drawer.MDCModalDrawerFoundation(adapter) : new drawer.MDCDismissibleDrawerFoundation(adapter);
        };
        MdcDrawer.prototype.ngAfterContentInit = function () {
            this._initListType();
        };
        MdcDrawer.prototype.ngOnDestroy = function () {
            var _a, _b, _c;
            this.open = false;
            (_a = this._focusTrap) === null || _a === void 0 ? void 0 : _a.destroy();
            (_b = this._scrimElement) === null || _b === void 0 ? void 0 : _b.remove();
            (_c = this._scrimSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
            this._destroyed.next();
            this._destroyed.complete();
            if (this._foundation && this._platform.isBrowser) {
                this._foundation.destroy();
            }
        };
        MdcDrawer.prototype._handleTransitionEnd = function (event) {
            this._foundation.handleTransitionEnd(event);
        };
        MdcDrawer.prototype._createScrim = function () {
            var _this = this;
            if (this._platform.isBrowser) {
                this._scrimElement = document.createElement('div');
                this._scrimElement.classList.add('mdc-drawer-scrim');
                this._getHostElement().insertAdjacentElement('afterend', this._scrimElement);
                this._scrimSubscription =
                    this._ngZone.runOutsideAngular(function () {
                        return rxjs.fromEvent(_this._scrimElement, 'click')
                            .subscribe(function () { return _this._ngZone.run(function () { return _this.open = false; }); });
                    });
            }
        };
        MdcDrawer.prototype._initFoundation = function () {
            this._getHostElement().classList.remove(drawer.cssClasses.MODAL);
            this._getHostElement().classList.remove(drawer.cssClasses.DISMISSIBLE);
            this._foundation = this.getDefaultFoundation();
            this._foundation.init();
            if (this.modal || this.dismissible) {
                this._getHostElement().classList.add(drawer.cssClasses.ROOT + "--" + this.drawer);
            }
            if (this._scrimElement) {
                if (this._scrimSubscription) {
                    this._scrimSubscription.unsubscribe();
                }
                this._scrimElement.remove();
                this._scrimElement = null;
            }
            if (this.modal) {
                this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
                this._updateFocusTrapState();
                this._createScrim();
            }
            else if (this._focusTrap) {
                this._focusTrap.destroy();
            }
            this._changeDetectorRef.markForCheck();
        };
        MdcDrawer.prototype._initListType = function () {
            if (this._list && (this._list.singleSelection || this._list.singleSelection === undefined)) {
                this._list.wrapFocus = true;
                this._list.singleSelection = true;
                this._list.useActivatedClass = true;
            }
        };
        /** Updates the enabled state of the focus trap. */
        MdcDrawer.prototype._updateFocusTrapState = function () {
            if (this._focusTrap) {
                this._focusTrap.enabled = this._isFocusTrapEnabled;
            }
        };
        MdcDrawer.prototype._trapFocus = function () {
            var _this = this;
            if (!this.autoFocus) {
                return;
            }
            this._focusTrap.focusInitialElementWhenReady().then(function (hasMovedFocus) {
                // If there were no focusable elements, focus the drawer itself so the keyboard navigation
                // still works. We need to check that `focus` is a function due to Universal.
                if (!hasMovedFocus && typeof _this._elementRef.nativeElement.focus === 'function') {
                    _this._elementRef.nativeElement.focus();
                }
            });
        };
        /** Restores focus to the element that was focused before the drawer opened. */
        MdcDrawer.prototype._releaseFocus = function () {
            if (!this.autoFocus) {
                return;
            }
            var activeEl = this._document && this._document.activeElement;
            if (activeEl && this._elementRef.nativeElement.contains(activeEl)) {
                if (this._elementFocusedBeforeDrawerWasOpened instanceof HTMLElement) {
                    this._focusMonitor.focusVia(this._elementFocusedBeforeDrawerWasOpened, this._openedVia);
                }
                else {
                    this._elementRef.nativeElement.blur();
                }
            }
            this._elementFocusedBeforeDrawerWasOpened = null;
            this._openedVia = null;
        };
        /** Saves a reference to the element that was focused before the drawer was opened. */
        MdcDrawer.prototype._savePreviouslyFocusedElement = function () {
            var _this = this;
            if (this._document) {
                this._elementFocusedBeforeDrawerWasOpened = this._document.activeElement;
                // Note that there is no focus method when rendering on the server.
                if (this._elementRef.nativeElement.focus) {
                    // Move focus onto the drawer immediately. Needs to be async, because the element
                    // may not be focusable immediately.
                    Promise.resolve().then(function () { return _this._elementRef.nativeElement.focus(); });
                }
            }
        };
        MdcDrawer.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcDrawer.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-drawer',
                        exportAs: 'mdcDrawer',
                        host: {
                            'role': 'navigation',
                            'class': 'mdc-drawer',
                            '(transitionend)': '_handleTransitionEnd($event)'
                        },
                        template: '<ng-content></ng-content>',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcDrawer.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: core.NgZone },
            { type: core.ChangeDetectorRef },
            { type: a11y.FocusTrapFactory },
            { type: a11y.FocusMonitor },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [common.DOCUMENT,] }] },
            { type: core.ElementRef }
        ]; };
        MdcDrawer.propDecorators = {
            open: [{ type: core.Input }],
            drawer: [{ type: core.Input }],
            autoFocus: [{ type: core.Input }],
            restoreFocus: [{ type: core.Input }],
            fixedAdjustElement: [{ type: core.Input }],
            opened: [{ type: core.Output }],
            closed: [{ type: core.Output }],
            openedChange: [{ type: core.Output }],
            drawerChange: [{ type: core.Output }],
            _list: [{ type: core.ContentChild, args: [list.MdcList, { static: false },] }]
        };
        return MdcDrawer;
    }(base.MDCComponent));

    var MdcDrawerTitle = /** @class */ (function () {
        function MdcDrawerTitle() {
        }
        MdcDrawerTitle.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDrawerTitle]',
                        host: { 'class': 'mdc-drawer__title' }
                    },] }
        ];
        return MdcDrawerTitle;
    }());
    var MdcDrawerSubtitle = /** @class */ (function () {
        function MdcDrawerSubtitle() {
        }
        MdcDrawerSubtitle.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDrawerSubtitle]',
                        host: { 'class': 'mdc-drawer__subtitle' }
                    },] }
        ];
        return MdcDrawerSubtitle;
    }());
    var MdcDrawerContent = /** @class */ (function () {
        function MdcDrawerContent() {
        }
        MdcDrawerContent.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-drawer-content, [mdcDrawerContent]',
                        host: { 'class': 'mdc-drawer__content' }
                    },] }
        ];
        return MdcDrawerContent;
    }());
    var MdcDrawerAppContent = /** @class */ (function () {
        function MdcDrawerAppContent() {
        }
        MdcDrawerAppContent.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-drawer-app-content, [mdcDrawerAppContent]',
                        host: { 'class': 'mdc-drawer-app-content' }
                    },] }
        ];
        return MdcDrawerAppContent;
    }());

    var DRAWER_DECLARATIONS = [
        MdcDrawer,
        MdcDrawerAppContent,
        MdcDrawerContent,
        MdcDrawerHeader,
        MdcDrawerSubtitle,
        MdcDrawerTitle
    ];
    var MdcDrawerModule = /** @class */ (function () {
        function MdcDrawerModule() {
        }
        MdcDrawerModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: [DRAWER_DECLARATIONS],
                        declarations: [DRAWER_DECLARATIONS]
                    },] }
        ];
        return MdcDrawerModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcDrawer = MdcDrawer;
    exports.MdcDrawerAppContent = MdcDrawerAppContent;
    exports.MdcDrawerContent = MdcDrawerContent;
    exports.MdcDrawerHeader = MdcDrawerHeader;
    exports.MdcDrawerModule = MdcDrawerModule;
    exports.MdcDrawerSubtitle = MdcDrawerSubtitle;
    exports.MdcDrawerTitle = MdcDrawerTitle;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-drawer.umd.js.map
